//people reducer types
export const LOADING_COMPANYWARD = "LOADING_COMPANYWARD";
export const LOAD_COMPANYWARD = "LOAD_COMPANYWARD";
export const COMPANYWARD_SAVE_REQUEST = "COMPANYWARD_SAVE_REQUEST";
export const COMPANYWARD_SAVE_SUCCESS = "COMPANYWARD_SAVE_SUCCESS";
export const FETCH_COMPANYWARD_REQUEST = "FETCH_COMPANYWARD_REQUEST";
export const FETCH_COMPANYWARD_REQUEST_SUCCESS =
  "FETCH_COMPANYWARD_REQUEST_SUCCESS";
export const FETCH_COMPANYWARD_COMPANY_LIST_REQUEST_SUCCESS =
  "FETCH_COMPANYWARD_COMPANY_LIST_REQUEST_SUCCESS";
